import { render, staticRenderFns } from "./AddNewFormulationCompositionPopup.vue?vue&type=template&id=dc8ff5ec&scoped=true&"
import script from "./AddNewFormulationCompositionPopup.vue?vue&type=script&lang=js&"
export * from "./AddNewFormulationCompositionPopup.vue?vue&type=script&lang=js&"
import style0 from "./AddNewFormulationCompositionPopup.vue?vue&type=style&index=0&id=dc8ff5ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc8ff5ec",
  null
  
)

export default component.exports